module.exports = __webpack_public_path__ + "img/joinCloud2.7abab852.png";